import React from "react";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Button, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

interface Props {
  onSubmit: (answer: boolean) => void;
  currentValue: string;
  currentCurrency: string;
  nextValue: string;
  nextCurrency: string;
  date: string;
}

export const ReplaceMeasureDataPrompt: React.FC<Props> = ({
  onSubmit,
  currentValue = "",
  currentCurrency = "",
  nextValue = "",
  nextCurrency = "",
  date = ""
}) => {
  return (
    <Stack
      sx={{
        width: "500px",
        height: "207px",
        backgroundColor: "#fff",
        padding: "30px",
        gap: "10px"
      }}
    >
      <Stack
        sx={{ flexDirection: "row", alignItems: "center", gap: "6px", pb: "10px", borderBottom: "2px solid #dae0e2" }}
      >
        <WarningAmberIcon sx={{ marginRight: "6px", color: "#f6992b" }} />
        <Typography sx={{ fontSize: "16px", lineHeight: "24px" }}>
          {`A value already exists for the selected date (${dayjs(date).toLocaleString()})`}
        </Typography>
      </Stack>
      <Typography sx={{ fontSize: "16px", lineHeight: "20px" }}>
        {"Do you want to replace the current value ( "}
        <strong>{parseFloat(currentValue).toLocaleString(undefined, { maximumFractionDigits: 2 })}</strong>
        {currentCurrency}
        {" )   with the new one ( "}
        <strong>{parseFloat(nextValue).toLocaleString(undefined, { maximumFractionDigits: 2 })}</strong>
        {nextCurrency}
        {" )?"}
      </Typography>
      <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", gap: "21px" }}>
        <Button onClick={() => onSubmit(false)} variant="contained">
          Cancel
        </Button>
        <Button variant="outlined" onClick={() => onSubmit(true)}>
          Replace
        </Button>
      </Stack>
    </Stack>
  );
};
